enum TENANT_ACTION_TYPES {
	GET_PUBLIC_SETTINGS = 'GET_PUBLIC_SETTINGS',
	GET_PUBLIC_SETTINGS_SUCCESS = 'GET_PUBLIC_SETTINGS_SUCCESS',
	GET_PUBLIC_SETTINGS_ERROR = 'GET_PUBLIC_SETTINGS_ERROR',
}

export default TENANT_ACTION_TYPES;
